<app-truck-sidebar></app-truck-sidebar>
<div class="truck-owner-details">
  <div class="row">
    <div class="col-md-6"></div>
    <div class="col-md-6 truck-owner-header-search">
      <input
        toUppercase
        appAlphanumericOnly
        id="Workorder"
        (focusout)="searchWo($event)"
        #newItem
        placeholder="Search Workorder Number"
      />
      <a class="truck-header-search-icon" *ngIf="search_btn">
        <img
          (click)="search(newItem.value)"
          src="../../../assets/img/search.svg"
        />
      </a>
      <a class="truck-header-search-icon" *ngIf="clear_btn">
        <img (click)="resetSearch()" src="../../../assets/img/cross_icon.svg" />
      </a>
    </div>
    <div class="col-md-12">
      <mat-card>
        <div class="trip-acoordion">
          <a
            [ngClass]="{ active: deliverOrderType == '-1' }"
            (click)="getTripsList('-1')"
            >All</a
          >
          <a
            [ngClass]="{ active: deliverOrderType == 'present_work_order' }"
            (click)="getTripsList('present_work_order')"
            >Ongoing</a
          >
          <a
            [ngClass]="{ active: deliverOrderType == 'completed' }"
            (click)="getTripsList('completed')"
            >Completed</a
          >
          <a
            [ngClass]="{ active: deliverOrderType == 'cancelled' }"
            (click)="getTripsList('cancelled')"
            >Cancelled</a
          >
        </div>
      </mat-card>
    </div>
  </div>
  <div class="truck-owner-items">
    <div class="to_container">
      <div [class.spinner]="loading"></div>

      <div class="row" *ngIf="!deliveryArray.length && !loading">
        <h4 class="error_msg">No Records Found.</h4>
      </div>
      <div class="row" *ngIf="deliveryArray.length">
      <div
        class="col-sm-6"
        *ngFor="let deliveryOrder of deliveryArray; let i = index"
      >
        <mat-card class="truck-list">
          <div class="row">
            <div
              class="do_id col-md-2"
              (click)="editCreditTrip(deliveryOrder)"
              matTooltip="Edit DO"
              matTooltipPosition="above"
            >
              {{ deliveryOrder.do_id }}
            </div>
          </div>
          <div class="row">
            <div class="col-md-5 truck_details_loc">
              <img src="../../../assets/img/location-payment.svg" alt="" />
              <div class="places">
                <p>
                  {{
                    deliveryOrder.workorderInfo[0]?.pickup_details
                      .from_city_name
                  }}
                </p>
                <p style="font-size: 12px">
                  Load: {{ deliveryOrder.workorderInfo[0]?.material_type }}
                </p>
                <p>
                  {{
                    deliveryOrder.workorderInfo[0]?.dropoff_details.to_city_name
                  }}
                </p>
              </div>
            </div>
            <div class="col-md-7">
              <div class="item-container">
                <div class="item-left">Wo No:</div>
                <div class="item-right">
                  {{ deliveryOrder.workorderInfo[0]?.workorder_id }}
                </div>
              </div>
              <div class="item-container">
                <div class="item-left">Total Tons:</div>
                <div class="item-right">
                  {{ deliveryOrder.do_quantity | number : "1.3-3" }}
                </div>
              </div>
              <div class="item-container">
                <div class="item-left">Price Per Tons:</div>
                <div class="item-right">₹{{ deliveryOrder.price_per_ton }}</div>
              </div>
              <div class="item-container">
                <div class="item-left">Pickup Date:</div>
                <div class="item-right">
                  {{ deliveryOrder.do_issue_date | date : "dd-MM-yyyy" }}
                </div>
              </div>
              <div class="item-container">
                <div class="item-left">Remaining Tons:</div>
                <div class="item-right">
                  {{ deliveryOrder.remaining_tons | number : "1.3-3" }}
                </div>
              </div>
            </div>
          </div>
          <div
            class="credit_trip d-flex justify-content-center align-items-center"
          >
            <h3>{{ deliveryOrder.truck_category?.truck_category_name }}</h3>
            <div *ngIf="deliveryOrder.remaining_tons != 0">
              <a class="item-delete-btn" (click)="addCreditTrip(deliveryOrder)"
                >Add Credit Trip</a
              >
            </div>
          </div>
        </mat-card>
      </div>
    </div>
    </div>
    <div *ngIf="last_page && last_page > 1" class="pagination">
      <button class="btn" [disabled]="fetch_page == 1">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="btn--icon"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          stroke-width="2"
          (click)="pagination('-1')"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M15 19l-7-7 7-7"
          />
        </svg>
      </button>
      <button class="btn" [disabled]="fetch_page == 1">
        <img
          src="../../../assets/img/pagination-left.svg"
          (click)="pagination('first')"
          alt=""
          class="btn--icon"
        />
      </button>
      <div class="pages">
        <a class="page" *ngIf="fetch_page > 0">{{ fetch_page }}</a>
      </div>
      <button class="btn" [disabled]="last_page == fetch_page">
        <img
          src="../../../assets/img/pagination-right.svg"
          (click)="pagination('last')"
          alt=""
          class="btn--icon"
        />
      </button>
      <button class="btn" [disabled]="last_page == fetch_page">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="btn--icon"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          stroke-width="2"
          (click)="pagination('1')"
        >
          <path
            stroke-linecap=" round"
            stroke-linejoin="round"
            d="M9 5l7 7-7 7"
          />
        </svg>
      </button>
    </div>
  </div>
</div>
